import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';

export const MakePaymentSessionApiActions = createActionGroup({
  source: 'Make Payment - Session API',
  events: {
    'Session Ownership Updated': props<{ userEmail: string }>(),
    'Session Ownership Update Error': props<{ error: HttpErrorResponse }>(),
  },
});
